import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
let store = new Vuex.Store({
    // 1. state
    state:{
        //语言的选择框
		sel_language:'cn',
        //弹框页面数据
        // cache_action_data:null,
    },

    // 2. getters
    getters:{
        
    },
    // 通常跟api接口打交道
    actions:{
     
    },
    // 4. mutations
    mutations:{
        // state指的是state的数据
        // name传递过来的数据
        change_lan(state,data){
            // console.log(c)
            if(data=='中文'){
                state.sel_language='cn'
            }
            if(data=='English'){
                state.sel_language='en'
            }
            if(data=='日本語'){
                state.sel_language='jp'
            }
        },
        // change_cache_action_data(state,data){
        //     state.cache_action_data=data
        // }
    }
});

export default store;